module.exports = __webpack_public_path__ + "static/media/aam-world.b9166fbd.jpg";